import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3783c43e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scrolltab-main" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, { class: "scroll-list" }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleList, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.id,
            href: '#' + item.id,
            class: _normalizeClass(item.select ? 'select': '')
          }, [
            (item.icon)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 0,
                  icon: item.icon
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(item.text), 1)
          ], 10, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "scroll-body",
      id: 'bc-scrolltab-' + _ctx.tabId,
      onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.bodyScroll && _ctx.bodyScroll(...args)))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 40, _hoisted_3)
  ]))
}